import React from 'react';
import PropTypes from 'prop-types';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { H3 } from '../../components';

const OrderDetailsSummaryBlock = ({ headerId, value }) => {
  const isPoNumber = headerId === 'orderstatus.poNumber';

  return (
    <>
      <H3 className='text-color-warm-grey'>
        <TranslatedCopy id={headerId} />
      </H3>
      <div
        className='body-3 pb3-sm'
        style={{
          textTransform: 'uppercase',
          overflowWrap: isPoNumber ? 'break-word' : 'normal'
        }}
        data-desc={`orderDetails_summary_${headerId.replace(/ /g, '_')}`}
      >
        {value}
      </div>
    </>
  );
};

OrderDetailsSummaryBlock.propTypes = {
  headerId: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired
};

export default OrderDetailsSummaryBlock;
